export const protocol = window.location.protocol;
export const hostnameBase = window.location.hostname;
